import styles from '../../../MultiStepPMSLogin.module.scss'
import propertyId from './propertyId.png'

const FindPropertyId = () => {
  return (
    <div className={styles.solutionContainer}>
      <p className={styles.descriptionText}>
        Best way to get property id of the hotel is by logging into Opera Cloud. If we
        have a login, this can be done on our side, or through screen share while on a
        call with the hotel.
      </p>
      <p className={styles.descriptionTextEmp}>
        After logging in to Opera Cloud, check out top right corner of the screen.
      </p>
      <img src={propertyId} alt="" />
      <p className={styles.descriptionText}>
        Here 69833 is the <span className={styles.descriptionTextEmp}>property id</span> .
        Note this down.
      </p>
    </div>
  )
}

export default FindPropertyId
